import { useEffect, useState } from 'react'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil"
import checkbox_active from 'src/assets/common/join/active_checkbox.png'
import checkbox from 'src/assets/common/join/checkbox.png'
import Modal from 'src/component/common/Modal/Modal'
import { useTermsQueryData } from "src/hooks/reactquery"
import { useModal } from 'src/hooks/useModal'
import { TYPE_JOIN_TERMS } from "src/service/constant/cmdtype"
import { convertTermsData } from 'src/service/join'
import { JoinTermsValue } from "src/store/Join"
import { JoinTermsSelector, JoinTermsState, TelTypeState } from "src/store/recoil/common"
import { JoinTermsAll, JoinTermsSome, JoinTermsWrap } from 'src/styles/views/Join'
import { JoinTermsDetail } from 'src/types/type'

const JoinTerms = () => {
    const [modalOption, setModalOption] = useState({title: "", content: ""})
    const {data: TermsListData, isSuccess} = useTermsQueryData(TYPE_JOIN_TERMS)
    const setJoinTerms = useSetRecoilState(JoinTermsState)
    const termsData = useRecoilValue(JoinTermsSelector)
    const {isOpen, toggle} = useModal()
    const TelType = useRecoilValue(TelTypeState)
    const [AllTermsAgree, setAllTermsAgree] = useState(false)
    const [termsAgree, setTermsAgree] = useRecoilState(JoinTermsValue)
    const ResetJoinTerms = useResetRecoilState(JoinTermsValue)
    const TermsModalOpen = (title: string, content: string) => {
        setModalOption({title: title, content: content})
        toggle()
    }

    const EachTerms = (order: number) => {
        const ArrCopy = [...termsAgree]
        ArrCopy[order - 1] = termsAgree[order - 1] === 1 ? 0 : 1
        setTermsAgree(ArrCopy)
    }
    const AllTerms = () => {
        const ArrCopy = [...termsAgree]
        if (!AllTermsAgree) {
            termsData?.Terms.forEach((terms: JoinTermsDetail) => {
                if (terms.Required === 1 && terms.Order !== undefined) {
                    ArrCopy[terms.Order - 1] = 1
                }
            })
        } else {
            ArrCopy.fill(0)
        }
        setTermsAgree(ArrCopy)
        setAllTermsAgree((AllTermsAgree) => !AllTermsAgree)
    }

    useEffect(() => {
        ResetJoinTerms()
        setAllTermsAgree(false)
    }, [TelType, ResetJoinTerms])

    useEffect(() => {
        if (isSuccess && TermsListData?.Body) {
            setJoinTerms(convertTermsData(TermsListData?.Body))
        }
    }, [TermsListData, isSuccess, setJoinTerms])

    useEffect(() => {
        if (termsData) {
            setAllTermsAgree(
                termsData.Terms
                    .filter((terms) => terms.Required === 1 && terms.Order !== undefined)
                    .every((terms) => termsAgree[terms.Order! - 1] === 1) ?? false
            )
        }
    }, [TelType, termsAgree, termsData])

    return (
        <JoinTermsWrap>
            <JoinTermsAll>
                <img src={AllTermsAgree ? checkbox_active : checkbox} alt='전체약관' onClick={AllTerms}/>
                <span>아래 약관을 확인하고 모두 동의합니다. (서비스 가입 외 용도로 사용하지 않습니다)</span>
            </JoinTermsAll>
            <JoinTermsSome>
                {termsData?.Terms.map((terms: JoinTermsDetail, index: number) => (
                    <div key={index}>
                        <img src={terms.Order !== undefined && termsAgree[terms.Order - 1] === 1 ? checkbox_active : checkbox}
                             onClick={() => terms.Order !== undefined && EachTerms(terms.Order)} alt="부분약관"/>
                        <p>{terms.Title}{terms.Required === 1 ? "(필수)" : "(선택)"}</p>
                        <span onClick={() => TermsModalOpen(terms?.Title, terms.Contents)}>보기</span>
                    </div>
                ))}
            </JoinTermsSome>
            <Modal isOpen={isOpen} type='terms' option={modalOption} ClickFunc={() => toggle()}/>
        </JoinTermsWrap>
    )
}
export default JoinTerms
